import React from 'react';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import styled from 'styled-components';
import history from '../../history';


const Styles = styled.div`
    .navbar {
        background-color: #222333
    }

    .navbar-brand, .navbar-nav .nav-link {
        color: #bbb;
        &:hover {
            color: white;
        }
    }
`;

export class NavigationBar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLogged: localStorage.getItem('user')
        }
        // this.onChange = this.onChange.bind(this);
        // this.onSubmit = this.onSubmit.bind(this);
        // this.updateState = this.updateState.bind(this);
    }

    logOut(e) {
        e.preventDefault();
        console.log(localStorage.getItem('user'))
        localStorage.removeItem('user');
        this.setState({isLogged: false});
        history.push('/');
    }

    render() {

        return (
        <Styles>
            <Navbar expand="lg" variant="dark">
                <Navbar.Brand href="/">Soroka's Operating Rooms System</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ml-auto">
                        <NavDropdown title="Wards & Units" id="collasible-nav-dropdown">
                            <NavDropdown.Item href="/surgical">General Surgery</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="/orthopedic">Orthopedic</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="/pre_operation">Pre Operation</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="/opmngmt">Operating Rooms Management</NavDropdown.Item>
                        </NavDropdown>
                        <Nav.Item><Nav.Link href="/about">About</Nav.Link></Nav.Item>
                        <Nav.Item><Nav.Link href="/contact">Contact</Nav.Link></Nav.Item>
                        { !this.state.isLogged 
                            ?
                            <Nav.Item><Nav.Link href="/register">Register</Nav.Link></Nav.Item>
                            :<Nav.Item><Nav.Link href="/" onClick={this.logOut.bind(this)}>Logout</Nav.Link></Nav.Item>}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </Styles>
        )
    }
}